import { AfterViewInit, Component, Input, OnInit } from '@angular/core'
import { BlockFieldsService } from 'src/app/block-services/block-fields.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { BlockDataService } from '../../block-services/block-data.service'
import { PagesService } from 'src/app/pages/website-builder/pages.service'
import { AppSettingsService } from 'src/app/settings/services/app-settings.service'
import { StorageService } from '../../e-commerce/orders/storage-service/storage.service'
import { getHeaderTemplateStyle } from 'src/app/blocks-wrapper/block-header/header-template-styles'

@Component({
  selector: 'block-header',
  templateUrl: './block-header.component.html',
  styleUrls: ['./block-header.component.scss']
})
export class BlockHeaderComponent implements OnInit, AfterViewInit {
  previewBlock = true
  styleFields = false
  blockData: any

  previewFields = false

  blockHeaderSrc = ''
  blockHeaderBg = ''
  blockFields: any
  blockFieldsCustomPage: any

  blockId = ''

  showProgress = false
  menuIconToggleChecked = true
  searchIconToggleChecked = true
  cartIconToggleChecked = true
  sidemenuIconToggleChecked = true

  // Website builder navbar properties
  isAuthenticated = false
  showLanguageSwitcher = false
  applicationSettings: any = null
  availablePages: any[] = []

  @Input() importedBlockData: any
  private _builderType: 'mobile' | 'website' = 'mobile'
  @Input()
  set builderType(value: 'mobile' | 'website') {
    this._builderType = value
  }
  get builderType(): 'mobile' | 'website' {
    // Auto-detect based on builderService context if not explicitly set
    if (this.builderService && this.builderService.headerBtn === 'websitePageEditor') {
      return 'website'
    }
    return this._builderType
  }

  constructor(
    public blockDataService: BlockDataService,
    public blockFieldsService: BlockFieldsService,
    public builderService: BuilderService,
    private pagesService: PagesService,
    private appSettingsService: AppSettingsService,
    private storageService: StorageService
  ) {
    // Load application settings for logo
    if (this.builderService.selectedProject) {
      this.appSettingsService.getSettingsByType(String(this.builderService.selectedProject), 'application_settings').then((settings: any) => {
        this.applicationSettings = settings
      })

      // Load available pages for navigation dropdown
      this.pagesService.getPages(this.builderService.selectedProject).subscribe((pages: any) => {
        if (pages) {
          this.availablePages = Object.values(pages).map((value: any) => ({
            id: value.page_id,
            name: value.page_name,
            title: value.title
          }))
        }
      })
    }
  }

  ngOnInit() {
    // Log imported data at the start of ngOnInit (before subscription)
    // Set blockId from imported data if available BEFORE subscribing
    if (this.importedBlockData && this.importedBlockData.id) {
      this.blockId = this.importedBlockData.id
    } else if (!this.blockId) {
      // For website builder, always use consistent 'static-header' ID
      if (this.builderType === 'website') {
        this.blockId = 'static-header'
      } else {
        this.blockId = this.blockDataService.getUniqueId(2)
      }
    }

    // For website builder, load from static blocks
    if (this.builderType === 'website' && this.builderService.selectedProject) {
      this.loadStaticHeader()
      return
    }

    // For mobile builder, use existing global header logic
    this.blockDataService.getGlobalHeader().subscribe(() => {
      this.blockFields = this.getBlockFields(this.blockId)
      this.blockFieldsCustomPage = this.getBlockFieldsCustomPage(this.blockId)
      // let headerBlockData = this.blockDataService.getSelectedBlockData(this.blockId);
      let headerBlockData = this.blockDataService.getAllBlocksData()[0]
      if (headerBlockData && headerBlockData.data.global_header == undefined) {
        headerBlockData.data.global_header = true
      }
      if (this.builderService.globals || headerBlockData?.data?.global_header || headerBlockData?.data?.global_header == undefined) {
        this.blockData = this.builderService.globalHeader
        headerBlockData = this.builderService.globalHeader
        if (!headerBlockData) {
          headerBlockData = {
            data: ''
          }
          this.blockData = headerBlockData
        }
        this.blockFieldsService.readGlobalHeader = true
        if (headerBlockData?.data) {
          headerBlockData.data.global_header = true
        } else {
          headerBlockData.data = {
            global_header: true
          }
        }

        // console.log("Read from Global Header");
      } else {
        this.blockData = this.importedBlockData ? this.importedBlockData : this.blockFieldsService.getHeaderBlockFields()
        headerBlockData = this.blockFieldsCustomPage
        this.blockFieldsService.readGlobalHeader = headerBlockData.data?.global_header == undefined ? true : headerBlockData.data?.global_header
        // console.log("Read from Local Header");
      }
      this.blockHeaderSrc = this.blockData.data?.src

      this.blockFieldsService.toggleChecked = headerBlockData.data?.type == 'color' ? true : false
      this.blockFieldsService.disable_header = headerBlockData.data?.disable_header == undefined ? false : headerBlockData.data?.disable_header
      this.menuIconToggleChecked = headerBlockData.data?.menuIcon == undefined ? true : headerBlockData.data?.menuIcon
      this.searchIconToggleChecked = headerBlockData.data?.searchIcon == undefined ? true : headerBlockData.data?.searchIcon
      this.cartIconToggleChecked = headerBlockData.data?.cartIcon == undefined ? true : headerBlockData.data?.cartIcon
      this.sidemenuIconToggleChecked = headerBlockData.data?.sidemenuIcon == undefined ? true : headerBlockData.data?.sidemenuIcon

      this.blockFieldsService.menuIconToggleChecked = this.menuIconToggleChecked
      this.blockFieldsService.searchIconToggleChecked = this.searchIconToggleChecked
      this.blockFieldsService.cartIconToggleChecked = this.cartIconToggleChecked
      this.blockFieldsService.sidemenuIconToggleChecked = this.sidemenuIconToggleChecked

      // Initialize website builder navbar properties
      if (headerBlockData.data) {
        this.isAuthenticated = headerBlockData.data.isAuthenticated || false
        this.showLanguageSwitcher = headerBlockData.data.showLanguageSwitcher || false
      }

      // console.log("header menu icon",headerBlockData.data?.menuIcon, this.menuIconToggleChecked);
      // console.log(headerBlockData, this.builderService.globalHeader, this.blockFieldsCustomPage, this.blockFieldsService.readGlobalHeader);
      // console.log(this.builderService.globalHeader);
      // console.log(this.blockFieldsService.readGlobalHeader, headerBlockData.data?.global_header);
      // this.toggleChanged(this.blockId);
      // this.toggleChanged(this.blockId, 'global_header', headerBlockData.data?.global_header);
      // this.toggleChanged(this.blockId, 'disable_header');
      // if( this.builderService.globals ) {
      //   let headerBlockFields = this.blockDataService.getSelectedBlockData(this.blockId);
      //   this.builderService.globalHeader = headerBlockFields;
      // }
      let gAdMob = headerBlockData.data?.gHeaderBanners
      if (gAdMob) {
        let gAdmobHeaderFlag = false
        for (const key in gAdMob) {
          if (Object.prototype.hasOwnProperty.call(gAdMob, key)) {
            const element = gAdMob[key]
            // console.log(element);
            if (element.status == 'active') {
              gAdmobHeaderFlag = true
            }
          }
        }
        this.blockDataService.gAdMobActive = gAdmobHeaderFlag
      }
    })
  }

  /**
   * Load static header from Firebase for website builder
   */
  loadStaticHeader() {
    // Always use 'static-header' ID for consistency
    this.blockId = 'static-header'

    // Find the header block in blocksData
    const headerBlock = this.blockDataService.blocksData.find((block: any) => block.type === 'header')
    if (headerBlock) {
      // Normalize the header block's ID to 'static-header'
      headerBlock.id = 'static-header'
      this.blockData = headerBlock
      this.blockFields = headerBlock

      // Initialize UI properties from loaded data
      if (headerBlock.data) {
        this.isAuthenticated = headerBlock.data.isAuthenticated || false
        this.showLanguageSwitcher = headerBlock.data.showLanguageSwitcher !== false
        this.blockHeaderSrc = headerBlock.data.src
        this.menuIconToggleChecked = headerBlock.data.menuIcon !== false
        this.searchIconToggleChecked = headerBlock.data.searchIcon !== false
        this.cartIconToggleChecked = headerBlock.data.cartIcon !== false
        this.sidemenuIconToggleChecked = headerBlock.data.sidemenuIcon !== false

        this.blockFieldsService.toggleChecked = headerBlock.data.type == 'color'
        this.blockFieldsService.disable_header = headerBlock.data.disable_header || false
        this.blockFieldsService.menuIconToggleChecked = this.menuIconToggleChecked
        this.blockFieldsService.searchIconToggleChecked = this.searchIconToggleChecked
        this.blockFieldsService.cartIconToggleChecked = this.cartIconToggleChecked
        this.blockFieldsService.sidemenuIconToggleChecked = this.sidemenuIconToggleChecked
      }

      console.log('Loaded header block from blocksData:', headerBlock)
    } else {
      // No header block in blocksData, load from Firebase and create one
      this.pagesService.getStaticBlock(this.builderService.selectedProject, 'header').subscribe((staticHeader: any) => {
        if (staticHeader && Object.keys(staticHeader).length > 0) {
          // Static header exists, load it
          this.blockData = staticHeader
          this.blockFields = staticHeader

          // Initialize UI properties from loaded data
          if (staticHeader.data) {
            this.isAuthenticated = staticHeader.data.isAuthenticated || false
            this.showLanguageSwitcher = staticHeader.data.showLanguageSwitcher !== false
            this.blockHeaderSrc = staticHeader.data.src
            this.menuIconToggleChecked = staticHeader.data.menuIcon !== false
            this.searchIconToggleChecked = staticHeader.data.searchIcon !== false
            this.cartIconToggleChecked = staticHeader.data.cartIcon !== false
            this.sidemenuIconToggleChecked = staticHeader.data.sidemenuIcon !== false

            this.blockFieldsService.toggleChecked = staticHeader.data.type == 'color'
            this.blockFieldsService.disable_header = staticHeader.data.disable_header || false
            this.blockFieldsService.menuIconToggleChecked = this.menuIconToggleChecked
            this.blockFieldsService.searchIconToggleChecked = this.searchIconToggleChecked
            this.blockFieldsService.cartIconToggleChecked = this.cartIconToggleChecked
            this.blockFieldsService.sidemenuIconToggleChecked = this.sidemenuIconToggleChecked
          }

          console.log('Static header loaded from Firebase:', staticHeader)
        } else {
          // No static header exists, initialize with defaults
          this.blockData = {
            data: {
              navItems: [{label: 'Home', page: 'home'}],
              isAuthenticated: false,
              showLanguageSwitcher: true,
              showCart: true,
              type: 'color',
              bgColor: '#ffffff'
            },
            style: {}
          }
          this.blockFields = this.blockData
          console.log('No static header found, using defaults')
        }
      })
    }
  }

  /**
   * Get template-specific style configuration
   * Each template (template1-6) has its own unique colors, fonts, and styling
   * Now uses centralized shared configuration from header-template-styles.ts
   */
  getTemplateSpecificStyle(templateId: string): any {
    return getHeaderTemplateStyle(templateId)
  }

  /**
   * Save static header to Firebase for website builder
   */
  saveStaticHeader() {
    if (this.builderType !== 'website') return

    const headerData = this.getBlockFields(this.blockId)
    const selectedTemplate = headerData.data?.headerTemplate || 'template2'

    // Get the template-specific style configuration
    const templateStyle = this.getTemplateSpecificStyle(selectedTemplate)

    // Create complete header data with template-specific style
    const completeHeaderData = {
      id: headerData.id || 'static-header',
      type: headerData.type || 'header',
      data: headerData.data || {},
      style: templateStyle
    }

    console.log(`Saving ${selectedTemplate} to Firebase with its unique style:`, {
      selectedTemplate: selectedTemplate,
      styleProperties: Object.keys(completeHeaderData.style || {}),
      completeData: completeHeaderData
    })

    // Update local blockData to trigger preview update
    this.blockData = { ...completeHeaderData }
    this.blockFields = { ...completeHeaderData }

    // Update the header block in blocksData array for preview to pick up changes
    const headerIndex = this.blockDataService.blocksData.findIndex((block: any) => block.id === this.blockId)
    if (headerIndex !== -1) {
      // Create new object reference to trigger Angular change detection
      this.blockDataService.blocksData[headerIndex] = { ...completeHeaderData, id: this.blockId }
      // Create new array reference to ensure change detection
      this.blockDataService.blocksData = [...this.blockDataService.blocksData]
    }

    this.pagesService.setStaticBlock(this.builderService.selectedProject, 'header', completeHeaderData).subscribe(() => {
      console.log(` ${selectedTemplate} saved successfully with its unique style!`)
    }, (error) => {
      console.error('Error saving static header:', error)
    })
  }

  ngAfterViewInit() {}

  toggleChanged(blockId: any, type: string = 'background') {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let headerBlockFields = this.getBlockFields(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...headerBlockFields.data }
    let clonedBlockFieldsStyle = { ...headerBlockFields.style }
    if (type == 'background') {
      clonedBlockFieldsData['type'] = this.blockFieldsService.toggleChecked ? 'color' : 'image'
      clonedBlockFieldsData['menuIcon'] = this.blockFieldsService.menuIconToggleChecked
      clonedBlockFieldsData['searchIcon'] = this.blockFieldsService.searchIconToggleChecked
      clonedBlockFieldsData['cartIcon'] = this.blockFieldsService.cartIconToggleChecked
      clonedBlockFieldsData['sidemenuIcon'] = this.blockFieldsService.sidemenuIconToggleChecked
    } else if (type == 'global_header') {
      clonedBlockFieldsData['global_header'] = this.blockFieldsService.readGlobalHeader ? true : false
      this.getBlockFieldsCustomPage(blockId).data.global_header = clonedBlockFieldsData['global_header']
      this.blockFields = this.getBlockFields(this.blockId)
    } else if (type == 'disable_header') {
      clonedBlockFieldsData['disable_header'] = this.blockFieldsService.disable_header ? true : false
    }

    headerBlockFields.data = clonedBlockFieldsData
    headerBlockFields.style = clonedBlockFieldsStyle
    if (this.builderService.globals) {
      this.builderService.globalHeader = headerBlockFields
    }

    // Save static header for website builder
    if (this.builderType === 'website') {
      this.saveStaticHeader()
    }
  }
  /**
   * Appends Block to the Preview, Initial checks if the block is added as initial block addition or appended live
   */
  addBlockToPreview(initial: any = '') {
    let blockHeaderData = {
      component: BlockHeaderComponent,
      index: 'latest',
      element: this,
      initial: initial
    }
    this.blockDataService.sendBlockData(blockHeaderData)
  }

  appendBlock() {
    let clonedBlockData = { ...this.blockData }
    this.blockId = this.blockDataService.appendBlocksData(clonedBlockData)
  }

  /**
   * Sync the clicked block on click inside the mobile preview
   */
  showData(blockId: any) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      // show data of the last element instead
      blockId = this.blockDataService.getLatestBlockId()
    }
    this.blockFieldsService.clickedBlockId = blockId
    this.blockDataService.sendCurrentBlock(BlockHeaderComponent)
  }

  // queryChange(query: any, blockId: any, $event: any, type: string) {
  //   console.log(blockId, this.blockDataService.checkBlockAvailability(blockId));
  //   // Check Block Availability before taking action
  //   if (!this.blockDataService.checkBlockAvailability(blockId)) {
  //     return;
  //   }
  //   let productsBlockFields = this.blockDataService.getSelectedBlockData(blockId);
  //   /**
  //    * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
  //    */
  //   let clonedBlockFieldsData = { ...productsBlockFields.data };
  //   let data = '';
  //   if (type == 'select') {
  //     data = $event.value
  //   } else if (type == 'text') {
  //     data = $event.currentTarget.value;
  //   } else if (type == 'slider') {
  //     data = $event.value;
  //   }

  //   clonedBlockFieldsData[query] = data;
  //   productsBlockFields.data = clonedBlockFieldsData;
  // }

  queryChange(query: any, blockId: any, $event: any, type: string, index = 0, dataType: string = 'menuItems') {
    // console.log(blockId, this.blockDataService.checkBlockAvailability(blockId), query);
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let headerBlockFields = this.getBlockFields(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...headerBlockFields.data }
    console.log(clonedBlockFieldsData)
    let data: any = ''
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value
    } else if (type == 'slider') {
      data = $event.currentTarget.value
    } else if (type == 'multilevelText') {
      data = $event.currentTarget.value
    } else if (type == 'multilevelSelect') {
      data = $event.value
    } else if (type == 'toggle') {
      data = $event.checked
      // Update component properties for website builder
      if (query === 'isAuthenticated') {
        this.isAuthenticated = data
      } else if (query === 'showLanguageSwitcher') {
        this.showLanguageSwitcher = data
      }
    } else if (type == 'multilevelToggle') {
      data = $event.checked
    }

    if (type == 'multilevelText' || type == 'multilevelSelect' || type == 'multilevelToggle') {
      clonedBlockFieldsData[dataType][index][query] = data
    } else {
      clonedBlockFieldsData[query] = data
    }
    headerBlockFields.data = clonedBlockFieldsData
    // console.log(headerBlockFields.data);
    // this.builderService.globalHeader = headerBlockFields;
    let gAdMob = headerBlockFields.data.gHeaderBanners
    if (gAdMob) {
      let gAdmobHeaderFlag = false
      for (const key in gAdMob) {
        if (Object.prototype.hasOwnProperty.call(gAdMob, key)) {
          const element = gAdMob[key]
          // console.log(element);
          if (element.status == 'active') {
            gAdmobHeaderFlag = true
          }
        }
      }
      this.blockDataService.gAdMobActive = gAdmobHeaderFlag
    }

    // Save static header for website builder
    if (this.builderType === 'website') {
      this.saveStaticHeader()
    }
  }

  addGBannerItem = (blockId: string) => {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let headerBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...headerBlockFields.data }
    let data: any = ''
    if (!clonedBlockFieldsData.gHeaderBanners) {
      clonedBlockFieldsData['gHeaderBanners'] = [
        {
          index: 0,
          status: 'inactive',
          bannerAdId: '',
          gHeaderBannerPage: 'Home'
        }
      ]
    } else {
      clonedBlockFieldsData.gHeaderBanners.push({
        index: clonedBlockFieldsData.gHeaderBanners.length,
        status: 'inactive',
        bannerAdId: '',
        gHeaderBannerPage: 'Home'
      })
    }

    headerBlockFields.data = clonedBlockFieldsData
  }

  hexToRgb = (hex: string) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        }
      : null
  }

  convertHex = (hex: string, opacity: number) => {
    let rgb: any = this.hexToRgb(hex)
    if (!rgb) {
      return
    }
    return `rgba(${rgb.r},${rgb.g},${rgb.b},${opacity})`
  }

  processFile(fileInput: any, type: string, name: string, blockId: string) {
    const file: File = fileInput.target.files[0]

    if (!file) {
      return
    }

    this.showProgress = true

    // Handle website logo upload to Supabase Storage
    if (name === 'websiteLogo') {
      const projectId = this.builderService.selectedProject
      const fileExtension = file.name.split('.').pop()
      const storagePath = `images/website_logo.${fileExtension}`

      this.storageService.uploadFile(file, projectId, storagePath).then(
        (downloadURL) => {
          this.showProgress = false
          let imgBlockFields = this.getBlockFields(blockId)
          let clonedBlockFieldsData = { ...imgBlockFields.data }

          clonedBlockFieldsData.logoUrl = downloadURL
          imgBlockFields.data = clonedBlockFieldsData

          // Save to static header for website builder
          if (this.builderType === 'website') {
            this.saveStaticHeader()
          }

          this.builderService.globalHeader = imgBlockFields
          console.log('Website logo uploaded to Supabase Storage:', storagePath)
        },
        (err) => {
          this.showProgress = false
          console.error('Error uploading logo:', err)
          alert('Error uploading logo. Please try again.')
        }
      )
    } else {
      // Use existing upload service for other file types
      const reader = new FileReader()
      reader.addEventListener('load', (event: any) => {
        this.builderService.uploadFileCustomerServer(file, this.builderService.selectedProject, type).subscribe(
          (res) => {
            this.showProgress = false
            let imgBlockFields = this.getBlockFields(blockId)
            let clonedBlockFieldsData = { ...imgBlockFields.data }

            if (name === 'navbarLogo') {
              clonedBlockFieldsData.logoUrl = res
              imgBlockFields.data = clonedBlockFieldsData
            } else {
              clonedBlockFieldsData.src = res
              imgBlockFields.data.type = 'image'
              imgBlockFields.data = clonedBlockFieldsData
            }

            this.builderService.globalHeader = imgBlockFields
          },
          (err) => {
            this.showProgress = false
            alert('error uploading file, please contact support')
          }
        )
      })

      reader.readAsDataURL(file)
    }
  }
  /**
   * get all the image block fields from the service and adjust the src only
   * @param $event change event on the input field
   */
  imgSrcChange($event: any, blockId: any) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
  }

  styleChange(style: any, blockId: any, $event: any, type: string) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let textBlockFields = this.getBlockFields(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...textBlockFields.style }
    let data = ''
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value
    } else if (type == 'slider') {
      data = $event.currentTarget.value + 'px'
    }

    clonedBlockFieldsData[style] = data
    textBlockFields.style = clonedBlockFieldsData
    // this.builderService.globalHeader = textBlockFields;

    // Save static header for website builder
    if (this.builderType === 'website') {
      this.saveStaticHeader()
    }
  }

  getBlockFields = (id: string) => {
    // For website builder, return the blockFields directly (loaded from static blocks)
    if (this.builderType === 'website' && this.blockFields) {
      return this.blockFields
    }

    // For mobile builder, use existing logic
    if (!this.builderService.globals && !this.blockFieldsService.readGlobalHeader) {
      return this.getBlockFieldsCustomPage(id)
    }
    if (this.builderService.globalHeader == undefined) {
      this.builderService.globalHeader = this.blockDataService.tempHeader
    }
    // move the data inside this.builderService.globalHeader and add it inside this.builderService.globalHeader.data
    // if(this.builderService.globalHeader && this.builderService.globalHeader?.data?.global_header == this.builderService.globalHeader?.global_header ) {
    //   const data = { ...this.builderService.globalHeader };
    //   delete data.data;
    //   this.builderService.globalHeader.data = data;
    // }
    return this.builderService.globalHeader
  }

  getBlockFieldsCustomPage = (id: string) => {
    if (this.importedBlockData) {
      return this.importedBlockData
    }
    if (!this.blockDataService.blocksData) {
      return false
    }
    return this.blockDataService.getSelectedBlockData(id)
  }

  showStyleTab = () => {
    this.previewBlock = false
    this.previewFields = false
    this.styleFields = true
  }

  showDataTab = () => {
    this.previewBlock = false
    this.previewFields = true
    this.styleFields = false
  }

  checkSidebar = () => {
    if (!this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkPreview = () => {
    if (this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkData = () => {
    if (this.previewFields) {
      return true
    }
    return false
  }

  checkStyle = () => {
    if (this.styleFields && !this.previewFields && !this.previewBlock) {
      return true
    }
    return false
  }

  checkSettings = () => {
    if (!this.checkSidebar() && !this.checkPreview()) {
      return true
    }
    return false
  }

  deleteGBannerItem = (blockId: string, gHeaderBannerIndex: number) => {
    let menuItemsBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    for (let count = 0; count < menuItemsBlockFields.data?.gHeaderBanners?.length; count++) {
      const element = menuItemsBlockFields.data?.gHeaderBanners[count]
      if (element.index == gHeaderBannerIndex) {
        menuItemsBlockFields.data.gHeaderBanners.splice(count, 1)
      }
    }
    this.reindexMenuItems(blockId)
  }

  reindexMenuItems = (blockId: string) => {
    let menuItemsBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    for (let i = 0; i < menuItemsBlockFields.data?.menuItems?.length; i++) {
      menuItemsBlockFields.data.menuItems[i].index = i
    }
  }

  // Website builder navbar methods
  addNavItem = (blockId: string) => {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let headerBlockFields = this.getBlockFields(blockId)
    let clonedBlockFieldsData = { ...headerBlockFields.data }

    if (!clonedBlockFieldsData.navItems) {
      clonedBlockFieldsData['navItems'] = [
        {
          label: 'Home',
          page: 'home'
        }
      ]
    } else {
      clonedBlockFieldsData.navItems.push({
        label: 'New Item',
        page: this.availablePages.length > 0 ? this.availablePages[0].name : 'home'
      })
    }

    headerBlockFields.data = clonedBlockFieldsData
  }

  deleteNavItem = (blockId: string, navItemIndex: number) => {
    let headerBlockFields = this.getBlockFields(blockId)
    if (headerBlockFields.data?.navItems && headerBlockFields.data.navItems.length > navItemIndex) {
      headerBlockFields.data.navItems.splice(navItemIndex, 1)
    }
  }

  reindexNavItems = (_blockId: string) => {
    // No longer needed since we're using array indices directly
    // Kept for backwards compatibility but does nothing
  }

  /**
   * Select a header template and save to blockData
   */
  selectHeaderTemplate(blockId: string, templateId: string) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }

    let headerBlockFields = this.getBlockFields(blockId)
    let clonedBlockFieldsData = { ...headerBlockFields.data }

    clonedBlockFieldsData['headerTemplate'] = templateId
    headerBlockFields.data = clonedBlockFieldsData

    // Update local blockData immediately
    this.blockData = { ...headerBlockFields }
    this.blockFields = { ...headerBlockFields }

    // Save static header for website builder
    if (this.builderType === 'website') {
      this.saveStaticHeader()
    }

    console.log('Header template changed to:', templateId)
  }
}
